import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './core/utils/auth-interceptor'; // Ajusta la ruta si es diferente
import { Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { authGuard } from 'src/app/modules/auth/auth.guard'; // Ajusta la ruta de importación


const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./modules/layout/layout.module').then((m) => m.LayoutModule),
  },
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'home',
    loadChildren: () => import('./modules/home/home.module').then((m) => m.HomedModule),
  },
  {
    path: 'product',
    loadChildren: () => import('./modules/products/product.module').then((m) => m.ProductModule),
  },
  {
    path: 'inmuebles',
    loadChildren: () => import('./modules/inmuebles/inmueble.module').then((m) => m.InmuebleModule),
  },
  {
    path: 'cart-items',
    loadChildren: () => import('./modules/cart-items/cart-items.module').then((m) => m.CartItemsModule),
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./modules/dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [authGuard]
  },
    {
    path: 'partner',
    loadChildren: () => import('./modules/partner/pages/partner-table/partner.module').then((m) => m.PartnerModule),
  },
  {
    path: 'errors',
    loadChildren: () => import('./modules/error/error.module').then((m) => m.ErrorModule),
  },
  { path: '**', redirectTo: 'errors/404' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule
  ],
  exports: [RouterModule],
  providers: [
    Idle,
    Keepalive,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ],
})
export class AppRoutingModule {}
